import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { ConstructionMetadataComponentAbstract } from '../../metadata-components/construction-metadata/construction-metadata.component.abstract';

@Component({
  selector: 'app-construction-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './construction-metadata-v2.component.html',
})
export class ConstructionMetadataV2Component extends ConstructionMetadataComponentAbstract {}
